'use client'

import styles from '@/blocks/server/ServerSection.module.css'

// Where the page turns from the platform to the library: the same kind of heading as the
// platform's, so the two parts of Indx read as two chapters.
export default function LibraryHeading() {
  return (
    <section className={`${styles.wrapper} ${styles.chapter}`} aria-labelledby="library-title">
      <div className={styles.text}>
        <span className={styles.eyebrow}>Indx Search Library 5.0</span>
        <h2 id="library-title">A full enterprise search in a library</h2>
        <p>
          The same engine as a NuGet package for .NET: search that recognises patterns in text instead of
          matching exact words, with filters, facets, boosts and vector search, in-process and with no
          server to run.
        </p>
      </div>
    </section>
  )
}
